/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

import {Component} from '@angular/core';

import {ReactiveFormsModule} from '@angular/forms';
import {BaseFormFieldDirective} from '../../base-form-field.directive';
import {IxModule} from '@siemens/ix-angular';
import {TranslateModule} from '@ngx-translate/core';
import {FieldLabelComponent} from '../field-label/field-label.component';

@Component({
  selector: 'app-language-text-input',
  imports: [
    IxModule,
    TranslateModule,
    ReactiveFormsModule,
    FieldLabelComponent,
  ],
  templateUrl: './language-text-input.component.html',
  styleUrl: '../input-components.scss',
})
export class LanguageTextInputComponent extends BaseFormFieldDirective {
  constructor() {
    super();
  }
}
